/**
 * Shared animation constants. Centralizing these makes the site's motion
 * personality tunable from one place instead of by sweeping six files.
 */

/** Cubic-bezier curve used by every entrance animation. */
export const EASE = [0.21, 0.47, 0.32, 0.98] as const

/** InfiniteMarquee scroll loop duration (seconds). */
export const MARQUEE_LOOP_DURATION = 35

/** FullPageScroller wheel/keyboard cooldown — prevents over-sensitive snap. */
export const SCROLL_COOLDOWN_MS = 700

/**
 * useInView viewport margin. Negative values mean the element must be that
 * far inside the viewport before the animation fires.
 *
 * - `primary` (`-80px`): hero / section headline entrance — fires earlier.
 * - `secondary` (`-60px`): staggered, slide, zoom items — fires once the
 *   element is more committed to being on-screen.
 */
export const INVIEW_MARGIN = {
  primary: '-80px',
  secondary: '-60px',
} as const
